import React from "react";

import { useInternalFeatures } from "~/hooks/use-internal-features";

interface InternalFeatureProps {
    children: React.ReactNode;
}

export default function InternalFeature({ children }: InternalFeatureProps) {
    const { enabled } = useInternalFeatures();
    if (!enabled) return null;

    return (
        <span className="rounded-lg border-2 bg-blue-200 text-blue-900">
            {children}
        </span>
    );
}
